import React from "react";
import { ExerciseForHourlySchedule } from "../../../models/ExerciseForHourlySchedule";
import EAAvailabilityDots from "../../shared/AvailabilityDots/EAAvailabilityDots";
import { format } from "date-fns";

interface IProps {
  data: { [name: string]: ExerciseForHourlySchedule[] };
  getPercentageFree: (capacity: number, reserved: number) => number;
}

const HourlyScheduleMobileTable: React.FC<IProps> = ({ data, getPercentageFree }) => {
  return (
    <div className="hourly-schedule-mobile">
      {Object.keys(data).map((item, index) => (
        <div className="hourly-schedule-item-container-mobile" key={index}>
          <span className="hourly-schedule-item-container-mobile-title">{item}</span>
          <div className="hours-container">
            {Object.values(data[item]).map((itemValue, itemIndex) => (
              <span key={itemIndex} className="hours-container-item">
                {format(itemValue.startTime, "HH:mm")}
                <EAAvailabilityDots
                  percentageFree={getPercentageFree(itemValue.capacity, itemValue.reserved)}
                  labelled={false}
                />
              </span>
            ))}
          </div>
        </div>
      ))}
    </div>

    // <table className="hourly-schedule-table">
    //   <tbody>
    //     {Object.keys(data).map((item, index) => (
    //       <>
    //         <tr key={index}>
    //           <td className="bold">{item}</td>
    //         </tr>
    //         <tr>
    //           {Object.values(data[item]).map((itemValue, itemIndex) => (
    //             <td key={itemIndex}>
    //               <div className={`hourly-schedule-table-item`}>
    //                 {format(itemValue.startTime, "HH:mm")}
    //                 <DotsDisplay percentageFree={getPercentageFree(itemValue.capacity, itemValue.reserved)} />
    //               </div>
    //             </td>
    //           ))}
    //         </tr>
    //       </>
    //     ))}
    //   </tbody>
    // </table>
  );
};

export default HourlyScheduleMobileTable;
